<template>
	<portal :to="portal">
		<div class="app-modal" v-show="isShow">
			<div class="app-modal-wrap" ref="wrap" @click="modalClose">
				<transition :name="anamationName">
					<div class="app-modal-content" ref="content">
						<button class="app-modal-close" ref="close-button" @click.prevent="modalClose"></button>
						<div v-if="title" class="app-modal-title">{{ title }}</div>
						<slot v-if="isShow" />
					</div>
				</transition>
			</div>
		</div>
	</portal>
</template>

<script>
export default {
	props: {
		title: String,
		portal: {
			type: String,
			default: 'modal'
		}
	},
	data() {
		return {
			isShow: false,
			anamationName: 'translate-y-top'
		};
	},
	methods: {
		modalOpen(id) {
			this.anamationName = 'translate-y-top';
			this.isShow = true;
			document.body.style.overflow = 'hidden';
			setTimeout(() => (this.$refs['wrap'].scrollTop = 0), 1);
		},
		modalClose(event) {
			if (
				!event ||
				event.target === this.$refs['close-button'] ||
				(event.target.contains(this.$refs['content']) && event.target != this.$refs['content'])
			) {
				this.anamationName = 'translate-y-bottom';
				this.isShow = false;
				document.body.style.overflow = 'auto';
			}
		},
		keyUp(e) {
			if (e.keyCode === 27) {
				this.modalClose(e);
			}
		}
	},
	created() {
		document.addEventListener('keyup', this.keyUp);
	},
	beforeDestroy() {
		document.removeEventListener('keyup', this.keyUp);
	}
};
</script>

<style lang="scss">
.app-modal {
	z-index: 100;
	position: fixed;
	width: 100%;
	height: 100%;
	position: fixed;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	backdrop-filter: blur(5px);
	overflow: hidden;
	&-wrap {
		overflow: auto;
		position: absolute;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		background: rgba($color: #444444, $alpha: 0.8);
	}
	&-title {
		text-align: center;
		color: #000;
		font-size: 27px;
		line-height: 36px;
		margin: 40px;
		margin-top: 20px;
		margin-bottom: 70px;
		font-weight: bold;
		text-transform: uppercase;
	}
	&-content {
		margin: 100px auto;
		max-width: 800px;
		position: relative;
		background: #ffffff;
		overflow: hidden;
		padding: 30px;
		padding-bottom: 25px;
		box-shadow: 0px 5px 15px rgba($color: #000000, $alpha: 0.1);
	}
	&-close {
		display: block;
		position: absolute;
		width: 35px;
		height: 35px;
		padding: 0;
		background: transparent;
		outline: none;
		border: none;
		background-image: url('./close.svg');
		background-repeat: no-repeat;
		background-position: center;
		cursor: pointer;
		right: 15px;
		top: 15px;
		&:hover {
			opacity: 0.7;
		}
	}
}
.translate-y-top-enter-active,
.translate-y-top-leave-active {
	transition: all 0.2s;
}
.translate-y-top-enter, .translate-y-ton-leave-to /* .fade-leave-active до версии 2.1.8 */ {
	transform: translateY(-50px);
	opacity: 0.2;
}

.translate-y-bootom-enter-active,
.translate-y-bootom-leave-active {
	transition: all 0.2s;
}
.translate-y-bootom-enter, .translate-y-bootom-leave-to /* .fade-leave-active до версии 2.1.8 */ {
	transform: translateY(-50px);
	opacity: 0.2;
}
</style>
